
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserData } from './model/userData.model';
import { BehaviorSubject, catchError, map, Observable, switchMap, tap, throwError } from 'rxjs';
import { MetadataResponse } from './model/response/metadataResponse.model';
import { AccountService } from '../apis/account/account.service';
import { PdpjService } from '../apis/pdpj/pdpj.service';
import { StringUtil } from 'src/app/shared/util/string-util';
import { UsuarioResponse } from './model/response/usuarioResponse.model';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {

  readonly USER_DATA = 'user_data';

  readonly ERRO_USUARIO_NAO_ENCONTRADO = '<b>Dados do usuário não encontrados.</b><br>Entre em contato com o Administrador Regional do seu tribunal ou alternativamente, você pode abrir um chamado em <a href="https://suporteti.cnj.jus.br/" target="_blank" rel="noopener noreferrer">https://suporteti.cnj.jus.br/</a>';
  public userData: BehaviorSubject<UserData> = new BehaviorSubject({} as UserData);

  constructor(
    private _pdpjService: PdpjService,
    private _accountService: AccountService
  ) {
    const storedUserData = sessionStorage.getItem(this.USER_DATA);
    if (storedUserData) {
      try {
        const parsedUserData = JSON.parse(storedUserData);
        this.userData.next(parsedUserData);
      } catch (e) {
        console.error('Erro ao parsear userData do sessionStorage', e);
      }
    }
  }

  public salvarUserData(token: string): Observable<UserData> {
    return this.obterInfoUsuario(token).pipe(
      switchMap(userData => this.obterComarca(userData)),
      tap(userData => this.atualizarUserData(userData)),
      catchError(err => {
        if (err.status === 404)
          return throwError(() => new Error(this.ERRO_USUARIO_NAO_ENCONTRADO));
        return throwError(() => err);
      })
    );
  }

  private obterInfoUsuario(token: string): Observable<UserData> {
    return this._accountService.getUserMetadata(token).pipe(
      map((response: HttpResponse<MetadataResponse>) => {
        const data = response.body?.metadata[0]?.value[0];
        if (!data) throw new Error(this.ERRO_USUARIO_NAO_ENCONTRADO);

        if (data.seq_orgao_externo != null && data.seq_orgao_externo != 0){
          console.warn('Acesso restrito - usuário externo.');
          throw new Error('<b>Acesso restrito para Servidores do Poder Judiciário</b>.<br> Para acessar o SerasaJud, é obrigatório realizar o login apenas utilizando CPF e senha cadastrados no sistema Corporativo do CNJ.');
        }

        return {
          documento: data.num_cpf,
          nome: data.nom_usuario,
          email: data.dsc_email,
          orgaoExterno: data.seq_orgao_externo,
          orgao: { id: data.seq_orgao?.toString(), nome: data.dsc_orgao },
        } as UserData;
      })
    );
  }

  private obterComarca(userData: UserData): Observable<UserData> {
    return this._pdpjService.getPerfilUsuario(userData.documento).pipe(
      map((response: HttpResponse<UsuarioResponse>) => {
        const data = response.body?.result;
        if(!data || !data.dscCidade || !data.sigUf || !data.codigoOrgao)
          throw new Error('<b>Não possui cadastro ou possui alguma dificuldade no acesso?</b> <br> Entre em contato com o Administrador Regional do seu tribunal ou alternativamente, você pode abrir um chamado em <a href="https://suporteti.cnj.jus.br/" target="_blank" rel="noopener noreferrer">https://suporteti.cnj.jus.br/</a>');

        return {
          ...userData,
          comarca: StringUtil.removeSpecialCharacters(data.dscCidade)
        };
      }),
      catchError(error => {
        console.warn('Erro ao obter nome da praça:', error);
        return throwError(() => error);
      })
    );
  }


  private atualizarUserData(userData: UserData) {
    sessionStorage.setItem(this.USER_DATA, JSON.stringify(userData));
    this.userData.next(userData);
  }

}

